var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.26728C4 4.93118 4.1317 4.60884 4.36612 4.37118C4.60054 4.13352 4.91848 4 5.25 4H17.75C18.0815 4 18.3995 4.13352 18.6339 4.37118C18.8683 4.60884 19 4.93118 19 5.26728V7.02965C18.9999 7.47775 18.8242 7.90747 18.5117 8.22427L14 12.7983V19.0705C14 19.229 13.9601 19.3848 13.884 19.5231C13.8079 19.6615 13.6982 19.7779 13.5653 19.8612C13.4324 19.9445 13.2806 19.9919 13.1245 19.9991C12.9684 20.0062 12.8131 19.9727 12.6733 19.9019L9.57583 18.3321C9.40281 18.2444 9.25729 18.1096 9.15559 17.9428C9.05388 17.7759 9.00001 17.5837 9 17.3876V12.7983L4.48833 8.22427C4.17575 7.90747 4.00009 7.47775 4 7.02965V5.26728ZM5.66667 5.68971V7.02965L10.3 11.727C10.4162 11.8447 10.5084 11.9844 10.5713 12.1382C10.6342 12.2921 10.6666 12.4569 10.6667 12.6234V16.9956L12.3333 17.8404V12.6234C12.3333 12.2872 12.465 11.9644 12.7 11.7279L17.3333 7.0288V5.68971H5.66667Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilterIcon);
export default __webpack_public_path__ + "static/media/userFilterIcon.15d6d8818f22a00c6d87712026e2f68a.svg";
export { ForwardRef as ReactComponent };